<template>
  <div class="body-edit">
    <div class="body-edit__head">版型及缝制修改要求</div>
    <div class="body-edit__item">
      <div class="body-edit__item-name">确认样衣版型</div>
      <div class="body-edit__item-value">{{info.confirmSamplePattern| formatString}}</div>
    </div>
    <div class="body-edit__item">
      <div class="body-edit__item-name">修改意见</div>
      <div class="body-edit__item-value">{{info.suggestion| formatString}}</div>
    </div>
    <div class="body-edit__item">
      <div class="body-edit__item-name">风险评估</div>
      <div class="body-edit__item-value">{{info.riskAssessment| formatString}}</div>
    </div>
    <div class="body-edit__item">
      <div class="body-edit__item-name">QC建议</div>
      <div class="body-edit__item-value">{{info.qcAdvise| formatString}}</div>
    </div>
  </div>
</template>

<script>
import { formatImgUrl } from "src/filter/modules/img";

export default {
  name: "print-edit",
  filters: {
    formatImgUrl,
    formatCodeList(array, keys) {
      return array
        .reduce((pre, next) => {
          const index = keys.findIndex(inner => inner.colorCode == next);
          if (index > -1) pre.push(keys[index].colorName);
          return pre;
        }, [])
        .join(",");
    },
    filterSizeName(obj) {
      const { sizeCode, sizeName } = obj;
      const str = sizeName.match(/[a-zA-Z]+/);
      if (sizeCode == "pieceSize" || sizeCode == "codeSize") return sizeName;
      if (!str) return sizeName;
      return str[0];
    },
    formatString(str) {
      if (!str) return "";
      return str.replace(/\s*/g, "");
    }
  },
  props: {
    info: {
      type: Object,
      default: () => ({})
    },
    isWoollen: {
      type: Boolean,
      default: false
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "src/sass/index";
@import "src/sass/modules/mixin";
$_normal_font: 4mm;
$_title_font: 5mm;
$box_width: 190mm;
$box_height: 277mm;
$_black: #333;
.default_text_over {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  overflow: hidden;
}
.default_border {
  border-top: 1px solid $_black;
  border-left: 1px solid $_black;
}
.default_title {
  height: 6mm;
  text-align: center;
}
.default_table {
  width: 100%;
  td {
    border-collapse: collapse;
  }
  td,
  th {
    border: 1px solid $_black;
    border: 1px solid $_black;
  }
}
// 版型分子修改要求
.body-edit {
  @include grid_template(100%, 13.5% 21.625% 21.625% 21.625% 21.625%);
  .body-edit__head {
    @extend .default_border;
    height: 8mm;
    font-weight: bold;
    text-align: center;
    border-right: 1px solid $_black;
  }
  .body-edit__item {
    @include grid_template(22% 78%, 100%);
    .body-edit__item-name {
      @extend .default_border;
      @include flex_center();
    }
  }
  .body-edit__item-value {
    white-space: pre-line;
    @extend .default_border;
    border-right: 1px solid $_black;
  }
}
</style>
